import React from 'react';
import { Collapse } from 'react-collapse';

import '@app/scss/components/topics.scss';

interface Topic {
	id?: number;
	name: string;
	text?: string;
}

interface Props {
	items: Array<Topic>;
}

const TopicNode: React.FC<{ item: Topic }> = (props) => {
	const { name, text } = props.item;
	const [isOpen, setOpen] = React.useState(false);

	return (
		<div className="topic">
			<div className={`collapse-trigger ${isOpen ? 'open' : ''}`} onClick={() => setOpen((prev) => !prev)}>
				<h3>
					{name}
				</h3>
				{text && <svg xmlns="http://www.w3.org/2000/svg" width="17" height="10" viewBox="0 0 17 10" fill="none">
					<path
						d="M8.49017 7.22786C8.16676 7.17436 2.95336 2.41643 1.81141 1.06935C1.37789 0.579178 0.602075 1.24884 1.0356 1.73902C3.17847
						4.45077 5.48354 7.08499 7.7075 9.75798C7.90488 9.96252 8.28563 10.0296 8.49017 9.83223C8.92041 9.37753 9.62878 8.77092 10.059
						8.31623C12.5522 6.02876 14.5699 3.68866 16.6472 1.05204C17.0175 0.576183 16.2667 -0.160863 15.8365 0.293828C13.4304 2.93 8.81357 7.28137 8.49017 7.22786Z"
						fill="#352557"
					/>
				</svg>}
			</div>
			{text && <Collapse isOpened={isOpen} checkTimeout={500}>
				<p className="topic-text h4" style={{ opacity: isOpen ? 1 : 0.1 }}>
					{text}
				</p>
			</Collapse>}
		</div>
	);
};

const emptyFaq: Array<Topic> = [
	{
		id: -1,
		name: 'no FAQ yet',
		text: '',
	},
];

const Topics: React.FC<Props> = ({ items }) => {
	return (
		<div className="topics-container">
			<ul className="topics">
				{(items.length ? items : emptyFaq)
					.slice(0, Math.ceil(items.length / 2))
					.map((item, i) => <li key={`${item.id}${i}`}><TopicNode item={item} /></li>)}
			</ul>
			{items.length > 1 ? <ul className="topics">
				{(items.length ? items : emptyFaq)
					.slice(Math.ceil(items.length / 2))
					.map((item, i) => <li key={`${item.id}${i}`}><TopicNode item={item} /></li>)}
			</ul> : null}
		</div>
	);
};

export default Topics;
